/** @format */

export const MIN_CONTAINER_HEIGHT = 604;

export const X_AXIS_HEIGHT = 46;

export const Y_AXIS_WIDTH = 40;

export const MIN_CHART_HEIGHT = 80;

export const DEFAULT_CHART_HEIGHT = 100;

export const CHARTS_GAP = 26;

export const SCATTER_HEIGHT = 48;

export const BRUSH_PADDING_HEIGHT = 72;

export const STUB_LAYER_HEIGHT = 140;

export const CHARTS_MARGIN_LEFT = 48;

export const CHARTS_MARGIN_RIGHT = 50;

export const CHARTS_MARGIN_TOP = 15;

export const CHARTS_MARGIN_BOTTOM = 16;

export const MAX_PEAK_LABELS = 2;

export const MAX_PIT_LABELS = 2;

export const FORECAST_KEYS = {
  Average: 'fc_key_average',
  Min: 'fc_key_min',
  Max: 'fc_key_max',
} as const;

export const WEEK_DAYS = 7;

export const MONTH_DAYS_MIN = 28;

export const MONTH_DAYS_MAX = 31;
